import { z } from 'zod';

const carouselDataSchema = z.object({
  title: z.string(),
  description: z.string(),
  image: z.string(),
});
type CarouselData = z.infer<typeof carouselDataSchema>;

const carouselSettingsSchema = z
  .object({
    autoplay: z.boolean(),
    autoplayInterval: z.number().optional(), // in milliseconds
    fade: z.boolean(),
    loop: z.boolean(),
    fadeSpeed: z.number(), // in milliseconds
    pagination: z.boolean(),
    loadFromCMS: z.boolean(), // if true, the carousel will load from the CMS / Translation API
    numberOfSlides: z.number().optional(), // it's required if loadFromCMS is true
    cmsContentKey: z.string().optional(), // it's required if loadFromCMS is true
  })
  .refine(
    (data) =>
      !data.loadFromCMS ||
      (data.loadFromCMS && data.numberOfSlides !== undefined),
    {
      message: 'numberOfSlides is required if loadFromCMS is true',
      path: ['numberOfSlides'],
    }
  )
  .refine(
    (data) =>
      !data.autoplay || (data.autoplay && data.autoplayInterval !== undefined),
    {
      message: 'autoplayInterval is required if autoplay is true',
      path: ['autoplayInterval'],
    }
  );
type CarouselSettings = z.infer<typeof carouselSettingsSchema>;

export {
  carouselDataSchema,
  carouselSettingsSchema,
  type CarouselData,
  type CarouselSettings,
};
